module.exports = __webpack_public_path__ + "img/microblog.ed8128e3.png";